import React from "react";
import style from "./about.scss";

const AboutPage = () => (
  <div className={style["about"]}>
    <h2>ABOUT ME</h2>
    <h3>GET TO KNOW ME BEFORE YOU DIVE INTO MY CONTENT.</h3>
  </div>
);

export default AboutPage;
